const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Получить токен от Clerk
export const getClerkToken = async (getToken) => {
  try {
    const token = await getToken();
    return token;
  } catch (error) {
    console.error('Ошибка получения токена:', error);
    return null;
  }
};

// Простой API вызов с токеном
export const apiCall = async (url, options = {}, getToken) => {
  try {
    console.log('🚀 API call to:', url);
    
    if (!url) {
      throw new Error('URL is required for API call');
    }
    
    const token = await getClerkToken(getToken);
    console.log('🔑 Token status:', token ? 'Available' : 'Missing');
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };
    
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    } else {
      console.log('❌ No token - request will be unauthenticated');
    }

    // Строим полный URL правильно - если URL уже полный, используем как есть
    // Если относительный, добавляем к базовому URL
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}/${url.replace(/^\/+/, '')}`;

    
    const response = await fetch(fullUrl, {
      ...options,
      headers,
    });

    console.log('📡 Response status:', response.status);
    
    return response;
  } catch (error) {
    console.error('💥 API call error:', error);
    throw error;
  }
}; 